import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

const API_MODEL_TO_ENDPOINT: Record<ApiModel, ApiEndpoint> = {
  [ApiModel.Account]: ApiEndpoint.Account,
  [ApiModel.AccountAction]: ApiEndpoint.AccountAction,
  [ApiModel.AccountStatus]: ApiEndpoint.AccountStatus,
  [ApiModel.AccountType]: ApiEndpoint.AccountType,
  [ApiModel.AccountTypeGridLayout]: ApiEndpoint.AccountTypeGridLayout,
  [ApiModel.AccountVariableDefinition]: ApiEndpoint.AccountVariableDefinition,
  [ApiModel.AnalyticsQueryTemplate]: ApiEndpoint.AnalyticsQueryTemplates,
  [ApiModel.ApiKey]: ApiEndpoint.ApiKey,
  [ApiModel.Blueprint]: ApiEndpoint.Blueprint,
  [ApiModel.Case]: ApiEndpoint.Case,
  [ApiModel.CaseAssignmentPolicy]: ApiEndpoint.CaseAssignmentPolicy,
  [ApiModel.CaseComment]: ApiEndpoint.CaseComment,
  [ApiModel.CaseMessage]: ApiEndpoint.CaseMessage,
  [ApiModel.CaseQueue]: ApiEndpoint.CaseQueue,
  [ApiModel.CaseQuery]: ApiEndpoint.CaseQuery,
  [ApiModel.CaseQueryResult]: ApiEndpoint.CaseQueryResult,
  [ApiModel.CaseTemplate]: ApiEndpoint.CaseTemplate,
  [ApiModel.CaseVariableDefinition]: ApiEndpoint.CaseVariableDefinition,
  [ApiModel.ComplianceRule]: ApiEndpoint.ComplianceRule,
  [ApiModel.Device]: ApiEndpoint.Device,
  [ApiModel.Document]: ApiEndpoint.Document,
  [ApiModel.DocumentGeneric]: ApiEndpoint.DocumentGeneric,
  [ApiModel.DocumentGovernmentId]: ApiEndpoint.DocumentGovernmentId,
  [ApiModel.DocumentFile]: ApiEndpoint.DocumentFile,
  [ApiModel.Inquiry]: ApiEndpoint.Inquiry,
  [ApiModel.CurrentInquirySession]: ApiEndpoint.CurrentInquirySession,
  [ApiModel.Graph]: ApiEndpoint.Graph,
  [ApiModel.GraphDatumType]: ApiEndpoint.GraphDatumType,
  [ApiModel.GraphNode]: ApiEndpoint.GraphNode,
  [ApiModel.GraphQuery]: ApiEndpoint.GraphQuery,
  [ApiModel.GraphQueryTemplate]: ApiEndpoint.GraphQueryTemplate,
  [ApiModel.GraphSnapshot]: ApiEndpoint.GraphSnapshot,
  [ApiModel.InquirySession]: ApiEndpoint.InquirySession,
  [ApiModel.Template]: ApiEndpoint.Template,
  [ApiModel.InquiryTemplate]: ApiEndpoint.InquiryTemplate,
  [ApiModel.InquiryTemplateVersion]: ApiEndpoint.InquiryTemplateVersion,
  [ApiModel.InquiryTemplateVersionDiff]: ApiEndpoint.InquiryTemplateVersion,
  [ApiModel.InquiryTemplateModule]: ApiEndpoint.InquiryTemplateModule,
  [ApiModel.InsightQuery]: ApiEndpoint.InsightQuery,
  [ApiModel.PartialInquiryTemplateVersion]: ApiEndpoint.InquiryTemplateVersion,
  [ApiModel.Importer]: ApiEndpoint.Importer,
  [ApiModel.ImporterPipelineCsv]: ApiEndpoint.ImporterPipeline,
  [ApiModel.ImporterPipelineMysql]: ApiEndpoint.ImporterPipeline,
  [ApiModel.ImporterPipelineSnowflake]: ApiEndpoint.ImporterPipeline,
  [ApiModel.ImporterPipelineRedshift]: ApiEndpoint.ImporterPipeline,
  [ApiModel.ImporterPipelineS3]: ApiEndpoint.ImporterPipeline,
  [ApiModel.ImporterPipelineGoogleSheets]: ApiEndpoint.ImporterPipeline,
  [ApiModel.ImporterRun]: ApiEndpoint.ImporterRun,
  [ApiModel.ImporterReportAddressLookup]: ApiEndpoint.ImporterReportAddressLookup,
  [ApiModel.ImporterReportAdverseMedia]: ApiEndpoint.ImporterReportAdverseMedia,
  [ApiModel.ImporterReportBusinessAdverseMedia]: ApiEndpoint.ImporterReportBusinessAdverseMedia,
  [ApiModel.ImporterReportBusinessLookup]: ApiEndpoint.ImporterReportBusinessLookup,
  [ApiModel.ImporterReportBusinessWatchlist]: ApiEndpoint.ImporterReportBusinessWatchlist,
  [ApiModel.ImporterReportEmailAddress]: ApiEndpoint.ImporterReportEmailAddress,
  [ApiModel.ImporterReportPhoneNumber]: ApiEndpoint.ImporterReportPhoneNumber,
  [ApiModel.ImporterReportPoliticallyExposedPerson]:
    ApiEndpoint.ImporterReportPoliticallyExposedPerson,
  [ApiModel.ImporterReportProfileNonAuthoritative]:
    ApiEndpoint.ImporterReportProfileNonAuthoritative,
  [ApiModel.ImporterReportSocialMedia]: ApiEndpoint.ImporterReportSocialMedia,
  [ApiModel.ImporterReportWatchlist]: ApiEndpoint.ImporterReportWatchlist,
  [ApiModel.PlatformNode]: ApiEndpoint.PlatformNode,
  [ApiModel.Report]: ApiEndpoint.Report,
  [ApiModel.ReportAddressLookup]: ApiEndpoint.ReportAddressLookup,
  [ApiModel.ReportAdverseMedia]: ApiEndpoint.ReportAdverseMedia,
  [ApiModel.ReportBusinessAdverseMedia]: ApiEndpoint.ReportBusinessAdverseMedia,
  [ApiModel.ReportBusinessAssociatedPersons]: ApiEndpoint.ReportBusinessAssociatedPersons,
  [ApiModel.ReportBusinessClassification]: ApiEndpoint.ReportBusinessClassification,
  [ApiModel.ReportBusinessIndustryClassification]: ApiEndpoint.ReportBusinessIndustryClassification,
  [ApiModel.ReportBusinessLiensLookup]: ApiEndpoint.ReportBusinessLiensLookup,
  [ApiModel.ReportBusinessLookup]: ApiEndpoint.ReportBusinessLookup,
  [ApiModel.ReportBusinessNonprofit]: ApiEndpoint.ReportBusinessNonprofit,
  [ApiModel.ReportBusinessOnlinePresence]: ApiEndpoint.ReportBusinessOnlinePresence,
  [ApiModel.ReportBusinessRegistrationsLookup]: ApiEndpoint.ReportBusinessRegistrationsLookup,
  [ApiModel.ReportBusinessSocialMedia]: ApiEndpoint.ReportBusinessSocialMedia,
  [ApiModel.ReportBusinessWatchlist]: ApiEndpoint.ReportBusinessWatchlist,
  [ApiModel.ReportBusinessWebsite]: ApiEndpoint.ReportBusinessWebsite,
  [ApiModel.ReportChainalysisAddressScreening]: ApiEndpoint.ReportChainalysisAddressScreening,
  [ApiModel.ReportClearbitBusinessLookup]: ApiEndpoint.ReportClearbitBusinessLookup,
  [ApiModel.ReportCoinbaseCheckCryptoRisk]: ApiEndpoint.ReportCoinbaseCheckCryptoRisk,
  [ApiModel.ReportCryptoAddressWatchlist]: ApiEndpoint.ReportCryptoAddressWatchlist,
  [ApiModel.ReportCustomList]: ApiEndpoint.ReportCustomList,
  [ApiModel.ReportEmailAddress]: ApiEndpoint.ReportEmailAddress,
  [ApiModel.ReportEquifaxOneview]: ApiEndpoint.ReportEquifaxOneview,
  [ApiModel.ReportFinraBrokerCheck]: ApiEndpoint.ReportFinraBrokerCheck,
  [ApiModel.ReportKyckrBusinessLookup]: ApiEndpoint.ReportKyckrBusinessLookup,
  [ApiModel.ReportMiddeskBusinessLookup]: ApiEndpoint.ReportMiddeskBusinessLookup,
  [ApiModel.ReportMxAccount]: ApiEndpoint.ReportMxAccount,
  [ApiModel.ReportPhoneNumber]: ApiEndpoint.ReportPhoneNumber,
  [ApiModel.ReportPoliticallyExposedPerson]: ApiEndpoint.ReportPoliticallyExposedPerson,
  [ApiModel.ReportProfile]: ApiEndpoint.ReportProfile,
  [ApiModel.ReportProfileNonAuthoritative]: ApiEndpoint.ReportProfileNonAuthoritative,
  [ApiModel.ReportScreening]: ApiEndpoint.ReportScreening,
  [ApiModel.ReportSecActionLookup]: ApiEndpoint.ReportSecActionLookup,
  [ApiModel.ReportSentilinkApplicationRisk]: ApiEndpoint.ReportSentilinkApplicationRisk,
  [ApiModel.ReportSentilinkScores]: ApiEndpoint.ReportSentilinkScores,
  [ApiModel.ReportSocialMedia]: ApiEndpoint.ReportSocialMedia,
  [ApiModel.ReportSynthetic]: ApiEndpoint.ReportSynthetic,
  [ApiModel.ReportTrmWalletScreening]: ApiEndpoint.ReportTrmWalletScreening,
  [ApiModel.ReportWatchlist]: ApiEndpoint.ReportWatchlist,
  [ApiModel.ReportSnapshot]: ApiEndpoint.ReportSnapshot,
  [ApiModel.ReportSnapshotWatchlist]: ApiEndpoint.ReportSnapshot,
  [ApiModel.ReportSnapshotAdverseMedia]: ApiEndpoint.ReportSnapshot,
  [ApiModel.ReportSnapshotBusinessNonprofit]: ApiEndpoint.ReportSnapshot,
  [ApiModel.ReportTemplate]: ApiEndpoint.ReportTemplate,
  [ApiModel.ReportTemplateAddressLookup]: ApiEndpoint.ReportTemplateAddressLookup,
  [ApiModel.ReportTemplateAdverseMedia]: ApiEndpoint.ReportTemplateAdverseMedia,
  [ApiModel.ReportTemplateBusinessAdverseMedia]: ApiEndpoint.ReportTemplateBusinessAdverseMedia,
  [ApiModel.ReportTemplateBusinessAssociatedPersons]:
    ApiEndpoint.ReportTemplateBusinessAssociatedPersons,
  [ApiModel.ReportTemplateBusinessClassification]: ApiEndpoint.ReportTemplateBusinessClassification,
  [ApiModel.ReportTemplateBusinessIndustryClassification]:
    ApiEndpoint.ReportTemplateBusinessIndustryClassification,
  [ApiModel.ReportTemplateBusinessLiensLookup]: ApiEndpoint.ReportTemplateBusinessLiensLookup,
  [ApiModel.ReportTemplateBusinessLookup]: ApiEndpoint.ReportTemplateBusinessLookup,
  [ApiModel.ReportTemplateBusinessNonprofit]: ApiEndpoint.ReportTemplateBusinessNonprofit,
  [ApiModel.ReportTemplateBusinessOnlinePresence]: ApiEndpoint.ReportTemplateBusinessOnlinePresence,
  [ApiModel.ReportTemplateBusinessRegistrationsLookup]:
    ApiEndpoint.ReportTemplateBusinessRegistrationsLookup,
  [ApiModel.ReportTemplateBusinessSocialMedia]: ApiEndpoint.ReportTemplateBusinessSocialMedia,
  [ApiModel.ReportTemplateBusinessWatchlist]: ApiEndpoint.ReportTemplateBusinessWatchlist,
  [ApiModel.ReportTemplateBusinessWebsite]: ApiEndpoint.ReportTemplateBusinessWebsite,
  [ApiModel.ReportTemplateChainalysisAddressScreening]:
    ApiEndpoint.ReportTemplateChainalysisAddressScreening,
  [ApiModel.ReportTemplateClearbitBusinessLookup]: ApiEndpoint.ReportTemplateClearbitBusinessLookup,
  [ApiModel.ReportTemplateCoinbaseCheckCryptoRisk]:
    ApiEndpoint.ReportTemplateCoinbaseCheckCryptoRisk,
  [ApiModel.ReportTemplateCryptoAddressWatchlist]: ApiEndpoint.ReportTemplateCryptoAddressWatchlist,
  [ApiModel.ReportTemplateCustomList]: ApiEndpoint.ReportTemplateCustomList,
  [ApiModel.ReportTemplateEmailAddress]: ApiEndpoint.ReportTemplateEmailAddress,
  [ApiModel.ReportTemplateEquifaxOneview]: ApiEndpoint.ReportTemplateEquifaxOneview,
  [ApiModel.ReportTemplateFinraBrokerCheck]: ApiEndpoint.ReportTemplateFinraBrokerCheck,
  [ApiModel.ReportTemplateKyckrBusinessLookup]: ApiEndpoint.ReportTemplateKyckrBusinessLookup,
  [ApiModel.ReportTemplateMiddeskBusinessLookup]: ApiEndpoint.ReportTemplateMiddeskBusinessLookup,
  [ApiModel.ReportTemplateMxAccount]: ApiEndpoint.ReportTemplateMxAccount,
  [ApiModel.ReportTemplateNovaCreditCashAtlas]: ApiEndpoint.ReportTemplateNovaCreditCashAtlas,
  [ApiModel.ReportTemplateNovaCreditCreditPassport]:
    ApiEndpoint.ReportTemplateNovaCreditCreditPassport,
  [ApiModel.ReportTemplatePhoneNumber]: ApiEndpoint.ReportTemplatePhoneNumber,
  [ApiModel.ReportTemplatePoliticallyExposedPerson]:
    ApiEndpoint.ReportTemplatePoliticallyExposedPerson,
  [ApiModel.ReportTemplateProfile]: ApiEndpoint.ReportTemplateProfile,
  [ApiModel.ReportTemplateProfileNonAuthoritative]:
    ApiEndpoint.ReportTemplateProfileNonAuthoritative,
  [ApiModel.ReportTemplateScreening]: ApiEndpoint.ReportTemplateScreening,
  [ApiModel.ReportTemplateSecActionLookup]: ApiEndpoint.ReportTemplateSecActionLookup,
  [ApiModel.ReportTemplateSentilinkApplicationRisk]:
    ApiEndpoint.ReportTemplateSentilinkApplicationRisk,
  [ApiModel.ReportTemplateSentilinkScores]: ApiEndpoint.ReportTemplateSentilinkScores,
  [ApiModel.ReportTemplateSocialMedia]: ApiEndpoint.ReportTemplateSocialMedia,
  [ApiModel.ReportTemplateSynthetic]: ApiEndpoint.ReportTemplateSynthetic,
  [ApiModel.ReportTemplateTrmWalletScreening]: ApiEndpoint.ReportTemplateTrmWalletScreening,
  [ApiModel.ReportTemplateWatchlist]: ApiEndpoint.ReportTemplateWatchlist,
  [ApiModel.ReportTemplateVersionAddressLookup]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionAdverseMedia]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionBusinessAdverseMedia]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionBusinessAssociatedPersons]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionBusinessClassification]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionBusinessIndustryClassification]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionBusinessLiensLookup]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionBusinessLookup]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionBusinessNonprofit]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionBusinessOnlinePresence]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionBusinessRegistrationsLookup]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionBusinessSocialMedia]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionBusinessWatchlist]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionBusinessWebsite]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionClearbitBusinessLookup]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionChainalysisAddressScreening]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionCryptoAddressWatchlist]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionCustomList]: ApiEndpoint.ReportTemplateVersionCustomList,
  [ApiModel.ReportTemplateVersionEmailAddress]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionEquifaxOneview]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionFinraBrokerCheck]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionKyckrBusinessLookup]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionMiddeskBusinessLookup]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionMxAccount]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionPhoneNumber]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionPoliticallyExposedPerson]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionProfile]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionProfileNonAuthoritative]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionScreening]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionSecActionLookup]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionSentilinkApplicationRisk]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionSentilinkScores]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionSocialMedia]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionSynthetic]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionTrmWalletScreening]: ApiEndpoint.ReportTemplateVersion,
  [ApiModel.ReportTemplateVersionWatchlist]: ApiEndpoint.ReportTemplateVersion,

  [ApiModel.ReportRun]: ApiEndpoint.ReportRunsCustomList, // TODO: [Lauren] fix this when report runs are fully supported
  [ApiModel.ReportRunCustomList]: ApiEndpoint.ReportRunsCustomList,

  [ApiModel.SAR]: ApiEndpoint.SAR,
  [ApiModel.SARConfiguration]: ApiEndpoint.SARConfiguration,
  [ApiModel.SelfieCenterOnly]: ApiEndpoint.SelfieCenterOnly,
  [ApiModel.SelfieProfileAndCenter]: ApiEndpoint.SelfieProfileAndCenter,

  [ApiModel.Verification]: ApiEndpoint.Verification,
  [ApiModel.VerificationAamva]: ApiEndpoint.VerificationAamva,
  [ApiModel.VerificationBusinessWebsite]: ApiEndpoint.VerificationBusinessWebsite,
  [ApiModel.VerificationCertificateKorea]: ApiEndpoint.VerificationCertificateKorea,
  [ApiModel.VerificationDatabase]: ApiEndpoint.VerificationDatabase,
  [ApiModel.VerificationDatabaseAadhaar]: ApiEndpoint.VerificationDatabaseAadhaar,
  [ApiModel.VerificationDatabaseBusiness]: ApiEndpoint.VerificationDatabaseBusiness,
  [ApiModel.VerificationDatabaseBusinessFootprint]:
    ApiEndpoint.VerificationDatabaseBusinessFootprint,
  [ApiModel.VerificationDatabaseEcbsv]: ApiEndpoint.VerificationDatabaseEcbsv,
  [ApiModel.VerificationDatabasePhoneCarrier]: ApiEndpoint.VerificationDatabasePhoneCarrier,
  [ApiModel.VerificationDatabaseSerpro]: ApiEndpoint.VerificationDatabaseSerpro,
  [ApiModel.VerificationDatabaseStandard]: ApiEndpoint.VerificationDatabaseStandard,
  [ApiModel.VerificationDatabaseTin]: ApiEndpoint.VerificationDatabaseTin,
  [ApiModel.VerificationDatabaseVatNumber]: ApiEndpoint.VerificationDatabaseVatNumber,
  [ApiModel.VerificationDigitalIdFinnishTrustNetwork]:
    ApiEndpoint.VerificationDigitalIdFinnishTrustNetwork,
  [ApiModel.VerificationDigitalIdOneId]: ApiEndpoint.VerificationDigitalIdOneId,
  [ApiModel.VerificationDigitalIdSerpro]: ApiEndpoint.VerificationDigitalIdSerpro,
  [ApiModel.VerificationDigitalIdSingpass]: ApiEndpoint.VerificationDigitalIdSingpass,
  [ApiModel.VerificationDigitalIdUkSharecode]: ApiEndpoint.VerificationDigitalIdUkSharecode,
  [ApiModel.VerificationDocument]: ApiEndpoint.VerificationDocument,
  [ApiModel.VerificationEmailAddress]: ApiEndpoint.VerificationEmailAddress,
  [ApiModel.VerificationGovernmentId]: ApiEndpoint.VerificationGovernmentId,
  [ApiModel.VerificationGovernmentIdNfc]: ApiEndpoint.VerificationGovernmentIdNfc,
  [ApiModel.VerificationMobileDriversLicense]: ApiEndpoint.VerificationMobileDriversLicense,
  [ApiModel.VerificationPhoneNumber]: ApiEndpoint.VerificationPhoneNumber,
  [ApiModel.VerificationSelfie]: ApiEndpoint.VerificationSelfie,
  [ApiModel.VerificationTemplate]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateAamva]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateBusinessWebsite]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateCertificateKorea]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDatabase]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDatabaseAadhaar]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDatabaseEcbsv]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDatabaseBusiness]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDatabaseBusinessFootprint]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDatabasePhoneCarrier]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDatabaseSerpro]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDatabaseStandard]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDatabaseTin]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDatabaseVatNumber]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDigitalIdFinnishTrustNetwork]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDigitalIdOneId]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDigitalIdSerpro]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDigitalIdSingpass]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDigitalIdUkSharecode]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateDocument]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateEmailAddress]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateGovernmentId]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateGovernmentIdNfc]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateMobileDriversLicense]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplatePhoneNumber]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateSelfie]: ApiEndpoint.VerificationTemplate,
  [ApiModel.VerificationTemplateVersion]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionAamva]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionBusinessWebsite]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionCertificateKorea]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDatabase]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDatabaseAadhaar]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDatabaseStandard]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDatabaseBusiness]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDatabaseBusinessFootprint]:
    ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDatabaseEcbsv]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDatabasePhoneCarrier]:
    ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDatabaseSerpro]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDatabaseTin]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDatabaseVatNumber]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDigitalIdFinnishTrustNetwork]:
    ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDigitalIdOneId]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDigitalIdSerpro]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDigitalIdSingpass]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDigitalIdUkSharecode]:
    ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionDocument]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionEmailAddress]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionGovernmentId]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionGovernmentIdNfc]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionMobileDriversLicense]:
    ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionPhoneNumber]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.VerificationTemplateVersionSelfie]: ApiEndpoint.VerificationTemplateVersion,
  [ApiModel.Organization]: ApiEndpoint.Organization,
  [ApiModel.OrganizationPlan]: ApiEndpoint.OrganizationPlan,
  [ApiModel.OrganizationPlanMigration]: ApiEndpoint.OrganizationPlanMigration,
  [ApiModel.OnboardingFlowV1]: ApiEndpoint.OnboardingFlowV1,
  [ApiModel.Invoice]: ApiEndpoint.Invoice,
  [ApiModel.CurrentUser]: ApiEndpoint.CurrentUser,
  [ApiModel.User]: ApiEndpoint.User,
  [ApiModel.UserAuditLog]: ApiEndpoint.UserAuditLog,
  [ApiModel.UserAuthentication]: ApiEndpoint.UserAuthentication,
  [ApiModel.UserNotification]: ApiEndpoint.UserNotification,
  [ApiModel.UserSession]: ApiEndpoint.UserSession,
  [ApiModel.Event]: ApiEndpoint.Event,
  [ApiModel.ApiLog]: ApiEndpoint.ApiLog,
  [ApiModel.Environment]: ApiEndpoint.Environment,
  [ApiModel.EnvironmentProduction]: ApiEndpoint.Environment,
  [ApiModel.EnvironmentSandbox]: ApiEndpoint.Environment,
  [ApiModel.Exporter]: ApiEndpoint.Exporter,
  [ApiModel.ExporterAccount]: ApiEndpoint.ExporterAccount,
  [ApiModel.ExporterInquiry]: ApiEndpoint.ExporterInquiry,
  [ApiModel.ExporterMetricsInquiry]: ApiEndpoint.ExporterMetricsInquiry,
  [ApiModel.ExporterCase]: ApiEndpoint.ExporterCase,
  [ApiModel.ExporterCustomFile]: ApiEndpoint.ExporterCustomFiles,
  [ApiModel.ExporterInsightQuery]: ApiEndpoint.ExporterInsightQueries,
  [ApiModel.ExporterDataset]: ApiEndpoint.ExporterDataset,
  [ApiModel.ExporterGraph]: ApiEndpoint.ExporterGraph,
  [ApiModel.ExporterMetricsVerificationVolume]: ApiEndpoint.ExporterMetricsVerificationVolume,
  [ApiModel.ExporterMetricsVerificationChecks]: ApiEndpoint.ExporterMetricsVerificationChecks,
  [ApiModel.ExporterReport]: ApiEndpoint.ExporterReport,
  [ApiModel.ExporterReviewQueueTask]: ApiEndpoint.ExporterReviewQueueTask,
  [ApiModel.ExporterTransaction]: ApiEndpoint.ExporterTransactions,
  [ApiModel.ExternalIntegration]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationCall]: ApiEndpoint.ExternalIntegrationCall,
  [ApiModel.ExternalIntegrationConfig]: ApiEndpoint.ExternalIntegrationConfig,
  [ApiModel.ExternalIntegrationConfigCredentialApiKey]: ApiEndpoint.ExternalIntegrationConfig,
  [ApiModel.ExternalIntegrationConfigCredentialBearer]: ApiEndpoint.ExternalIntegrationConfig,
  [ApiModel.ExternalIntegrationConfigCredentialBasic]: ApiEndpoint.ExternalIntegrationConfig,
  [ApiModel.ExternalIntegrationConfigCredentialOauth2Password]:
    ApiEndpoint.ExternalIntegrationConfig,
  [ApiModel.ExternalIntegrationDataSource]: ApiEndpoint.ExternalIntegrationDataSource,
  [ApiModel.ExternalIntegrationDataSourceCsv]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationDataSourceMongodb]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationDataSourceMysql]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationDataSourcePostgres]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationDataSourceRedshift]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationDataSourceGoogleSheets]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationDataSourceSnowflake]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationDataSourceS3]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationEnrichmentChainalysis]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationEnrichmentEquifaxOneview]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationEnrichmentKyckr]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationEnrichmentMiddesk]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationEnrichmentMx]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationEnrichmentSentilink]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationEnrichmentTrm]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationLog]: ApiEndpoint.ExternalIntegrationLog,
  [ApiModel.ExternalIntegrationProductivity]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationProductivityHubspotOAuth]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationProductivityOpenAi]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationProductivitySalesforceOAuth]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationProductivitySlackOAuth]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationProductivityZendeskOAuth]: ApiEndpoint.ExternalIntegration,
  [ApiModel.ExternalIntegrationVendor]: ApiEndpoint.ExternalIntegrationVendor,
  [ApiModel.PasswordResetEmail]: ApiEndpoint.PasswordReset,
  [ApiModel.SimulatePreset]: ApiEndpoint.SimulatePreset,
  [ApiModel.SimulatePresetVerification]: ApiEndpoint.SimulatePreset,
  [ApiModel.TableView]: ApiEndpoint.TableView,
  [ApiModel.Theme]: ApiEndpoint.Theme,
  [ApiModel.ThemeSet]: ApiEndpoint.ThemeSet,
  [ApiModel.Transaction]: ApiEndpoint.Transaction,
  [ApiModel.TransactionLabel]: ApiEndpoint.TransactionLabel,
  [ApiModel.TransactionStatus]: ApiEndpoint.TransactionStatus,
  [ApiModel.TransactionType]: ApiEndpoint.TransactionType,
  [ApiModel.TransactionTypeGridLayout]: ApiEndpoint.TransactionTypeGridLayout,
  [ApiModel.TransactionVariableDefinition]: ApiEndpoint.TransactionVariableDefinition,
  [ApiModel.Translations]: ApiEndpoint.Translations,
  [ApiModel.TriggerComputedField]: ApiEndpoint.Trigger,
  [ApiModel.TriggerEvent]: ApiEndpoint.Trigger,
  [ApiModel.TriggerSchedule]: ApiEndpoint.Trigger,
  [ApiModel.TriggerRecurring]: ApiEndpoint.Trigger,
  [ApiModel.TriggerAccount]: ApiEndpoint.Trigger,
  [ApiModel.TriggerApi]: ApiEndpoint.Trigger,
  [ApiModel.TriggerCase]: ApiEndpoint.Trigger,
  [ApiModel.TriggerDirect]: ApiEndpoint.Trigger,
  [ApiModel.Webhook]: ApiEndpoint.Webhook,
  [ApiModel.Workflow]: ApiEndpoint.Workflow,
  [ApiModel.WorkflowBlock]: ApiEndpoint.WorkflowBlock,
  [ApiModel.WorkflowDeployment]: ApiEndpoint.WorkflowDeployment,
  [ApiModel.WorkflowModule]: ApiEndpoint.WorkflowModule,
  [ApiModel.WorkflowRun]: ApiEndpoint.WorkflowRun,
  [ApiModel.WorkflowRunSimulated]: ApiEndpoint.WorkflowRun,
  [ApiModel.WorkflowRunStep]: ApiEndpoint.WorkflowRunStep,
  [ApiModel.WorkflowRunStepAction]: ApiEndpoint.WorkflowRunStep,
  [ApiModel.WorkflowRunStepConditional]: ApiEndpoint.WorkflowRunStep,
  [ApiModel.WorkflowRunStepParallel]: ApiEndpoint.WorkflowRunStep,
  [ApiModel.WorkflowRunStepLoop]: ApiEndpoint.WorkflowRunStep,
  [ApiModel.WorkflowRunStepModule]: ApiEndpoint.WorkflowRunStep,
  [ApiModel.WorkflowRunStepWait]: ApiEndpoint.WorkflowRunStep,
  [ApiModel.WorkflowRunVariablePersonaObject]: ApiEndpoint.WorkflowRunStep,
  [ApiModel.WorkflowRunVariablePlatformIntegration]: ApiEndpoint.WorkflowRunStep,
  [ApiModel.WorkflowRunVariableOutput]: ApiEndpoint.WorkflowRunStep,
  [ApiModel.WorkflowRunVariableTriggerParams]: ApiEndpoint.WorkflowRunStep,
  [ApiModel.WorkflowRunVariableLoop]: ApiEndpoint.WorkflowRunStep,
  [ApiModel.WorkflowVersion]: ApiEndpoint.WorkflowVersion,
  [ApiModel.List]: ApiEndpoint.List,
  [ApiModel.ListGovernmentIdNumber]: ApiEndpoint.List,
  [ApiModel.ListIpAddress]: ApiEndpoint.List,
  [ApiModel.ListName]: ApiEndpoint.List,
  [ApiModel.ListPhoneNumber]: ApiEndpoint.List,
  [ApiModel.ListEmailAddress]: ApiEndpoint.List,
  [ApiModel.ListGeolocation]: ApiEndpoint.List,
  [ApiModel.ListBrowserFingerprint]: ApiEndpoint.List,
  [ApiModel.ListDeviceFingerprint]: ApiEndpoint.List,
  [ApiModel.ListString]: ApiEndpoint.List,
  [ApiModel.ListFace]: ApiEndpoint.List,
  [ApiModel.ListCountry]: ApiEndpoint.List,
  [ApiModel.ListField]: ApiEndpoint.List,
  [ApiModel.ListSelfieBackground]: ApiEndpoint.List,
  [ApiModel.ListItem]: ApiEndpoint.ListItem,
  [ApiModel.ListItemGovernmentIdNumber]: ApiEndpoint.ListItem,
  [ApiModel.ListItemIpAddress]: ApiEndpoint.ListItem,
  [ApiModel.ListItemName]: ApiEndpoint.ListItem,
  [ApiModel.ListItemPhoneNumber]: ApiEndpoint.ListItem,
  [ApiModel.ListItemEmailAddress]: ApiEndpoint.ListItem,
  [ApiModel.ListItemGeolocation]: ApiEndpoint.ListItem,
  [ApiModel.ListItemBrowserFingerprint]: ApiEndpoint.ListItem,
  [ApiModel.ListItemDeviceFingerprint]: ApiEndpoint.ListItem,
  [ApiModel.ListItemFace]: ApiEndpoint.ListItem,
  [ApiModel.ListItemCountry]: ApiEndpoint.ListItem,
  [ApiModel.ListItemField]: ApiEndpoint.ListItem,
  [ApiModel.ListItemString]: ApiEndpoint.ListItem,
  [ApiModel.ListItemSelfieBackground]: ApiEndpoint.ListItem,
  [ApiModel.ListMatch]: ApiEndpoint.ListMatch,
  [ApiModel.WebhookEvent]: ApiEndpoint.WebhookEvent,
  [ApiModel.ReviewQueue]: ApiEndpoint.ReviewQueue,
  [ApiModel.ReviewQueueTask]: ApiEndpoint.ReviewQueueTask,
  [ApiModel.Tag]: ApiEndpoint.Tag,
  [ApiModel.Role]: ApiEndpoint.Role,
  [ApiModel.Team]: ApiEndpoint.Team,
  [ApiModel.WorkrampInstantAuth]: ApiEndpoint.WorkrampInstantAuth,
};

export const toEndpoint = (type: ApiModel): ApiEndpoint => API_MODEL_TO_ENDPOINT[type];
